import { $hasFeature } from '@/core/utils/VueAcl'

export const attributesMixin = {
  methods: {
    setFilterableAttributes() {
      if (
        this.model.type === 'events' &&
        this.model.config.event === 'purchase'
      ) {
        this.steps[1].props.groupedFilterableAttributes = this.purchaseEventAttributes()
        this.steps[1].props.filterableAttributes = []
      } else if (this.model.type === 'events') {
        this.steps[1].props.groupedFilterableAttributes = this.eventAttributes()
        this.steps[1].props.filterableAttributes = []
      } else {
        this.steps[1].props.groupedFilterableAttributes = []
        this.steps[1].props.filterableAttributes = this.profileAttributes()
      }
    },

    profileAttributes() {
      return [
        'user_id',
        ...($hasFeature('customerIdEnabled') ? ['customer_id'] : []),
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription',
        ...($hasFeature('subscriptionTracking') ? ['timestamp'] : [])
      ]
    },

    eventAttributes() {
      return [
        {
          groupName: this.$t('Automations_Import_Attribute_Group_Profile'),
          attributes: this.getProfileAttributes(true)
        },
        {
          groupName: this.$t(
            'Automations_Import_Attribute_Group_Event_Metadata'
          ),
          attributes: ['timestamp']
        },
        {
          groupName: this.$t('Automations_Import_Attribute_Group_Event'),
          attributes: ['Import']
        }
      ]
    },

    purchaseEventAttributes() {
      return [
        {
          groupName: this.$t('Automations_Import_Attribute_Group_Profile'),
          attributes: this.getProfileAttributes(true)
        },
        {
          groupName: this.$t('Automations_Import_Attribute_Group_Event'),
          attributes: ['timestamp']
        }
      ]
    },

    getProfileAttributes(emailUnique = false) {
      return [
        'user_id',
        ...($hasFeature('customerIdEnabled') ? ['customer_id'] : []),
        ...($hasFeature('profileIdfybyEmail') &&
        (emailUnique ? $hasFeature('profileEmailUnique') : true)
          ? ['email']
          : [])
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/imports/mixins/AttributesMixin.js